import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { useEffect, useCallback } from 'react';
import Icon from '../../components/Icon';
import { GoogleService } from './GoogleService';
import { Button } from '@mui/material';

export interface IGoogleLoginButtonProps {
  setLoading(isLoading: boolean): void;
  onLoginFinished(response: any): void | Promise<void>; // <-- Added here
}

const GoogleLoginButton = (props: IGoogleLoginButtonProps) => {
  const { setLoading, onLoginFinished } = props;

  useEffect(() => {
    GoogleService.init();
  }, []);

  const loginWithGoogle = useCallback(async () => {
    setLoading(true);
    try {
      await GoogleService.login(onLoginFinished);
    } finally {
      setLoading(false);
    }
  }, [onLoginFinished, setLoading]);

  return (
    <Button
      startIcon={<Icon icon={faGoogle} />}
      style={{
        color: 'white',
        borderRadius: '30px',
        backgroundImage: 'unset',
        fontWeight: 'bold',
        textTransform: 'none',
        background: 'linear-gradient(90deg, #4285F4 0%, #EA4335 33%, #FBBC05 66%, #34A853 100%)',
      }}
      onClick={loginWithGoogle}
      fullWidth
    >
      Mit Google anmelden
    </Button>
  );
};

export default GoogleLoginButton;
